import styled from 'styled-components';

import { colorsPalettes, setFontVariant, truncateText } from '@similarweb/styles';

export const StyledLegendBulletContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const StyledLegendBulletCircle = styled.span<{ color: string }>`
  border-radius: 50%;
  background-color: ${({ color }) => color};
  width: 7px;
  height: 7px;
  display: inline-block;
`;

export const StyledLegendBulletName = styled.span`
  display: inline-block;
  max-width: 130px;
  ${truncateText()};
  ${setFontVariant('listItem3', colorsPalettes.carbon[500])};
`;
